import type { Film } from '@/types/content';

export const films: Film[] = [
  {
    id: 'night-tender',
    title: '夜色温柔',
    category: 'drama',
    subcategory: '都市情感',
    year: 2024,
    region: '日本',
    duration: 118,
    director: '佐藤澪',
    cast: ['高桥悠', '森川绫', '井上透'],
    rating: 8.4,
    tags: ['都市', '夜色', '克制叙事'],
    summary: '三个夜晚、两个陌生人，一段关于倾听与克制的关系。',
    synopsis:
      '深夜的居酒屋、末班车与无人接听的电话，构成两个陌生人交错的三个夜晚。影片大量采用固定机位与自然光，用克制的对话推进关系，把情绪留在沉默与留白之中。导演佐藤澪以近乎纪录片的耐心，拍出一段不急于抵达终点的都市情感。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20art%20house%20film%20poster%20artwork%2C%20elegant%20woman%20silhouette%20in%20silk%20gown%20standing%20by%20rain%20streaked%20window%20at%20night%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-night-tender&orientation=portrait',
    publishedAt: '2025-05-18',
    popularity: 96,
  },
  {
    id: 'neon-below',
    title: '霓虹之下',
    category: 'drama',
    subcategory: '悬疑叙事',
    year: 2023,
    region: '韩国',
    duration: 126,
    director: '尹度贤',
    cast: ['韩彩元', '李瑞准', '郑河那'],
    rating: 8.1,
    tags: ['悬疑', '城市', '双线叙事'],
    summary: '一段被同一通电话反复打断的夜晚，真相藏在城市缝隙里。',
    synopsis:
      '一名夜班广播员与一位常客在同一栋大楼里反复遇见，却对彼此的过去各执一词。影片以双线叙事交叉推进，霓虹、监控画面与深夜电台交织成一座城市的另一面。节奏冷静，情绪却在结尾处骤然收紧。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20art%20house%20film%20poster%20artwork%2C%20lone%20figure%20in%20long%20coat%20under%20blurred%20rainy%20neon%20signage%2C%20back%20view%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-neon-below&orientation=portrait',
    publishedAt: '2025-04-02',
    popularity: 88,
  },
  {
    id: 'afternoon-study',
    title: '午后书房',
    category: 'art',
    subcategory: '唯美摄影',
    year: 2024,
    region: '法国',
    duration: 94,
    director: '克莱尔·莫兰',
    cast: ['艾洛蒂·鲁', '让·巴尼耶'],
    rating: 8.6,
    tags: ['自然光', '室内', '摄影集'],
    summary: '一间书房、一整个夏天，光影比台词说了更多。',
    synopsis:
      '整部作品发生在一间朝西的书房里。午后四点的光从百叶窗斜切进来，落在书脊、地毯与皮肤上。导演用极少的台词与大量静止镜头，记录两个人共处的整个夏天，被评论者称为「一部可以听见呼吸的摄影集」。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20art%20house%20film%20poster%20artwork%2C%20sunlit%20study%20room%20with%20linen%20curtains%20and%20warm%20afternoon%20light%20falling%20across%20books%2C%20empty%20vintage%20chair%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20no%20text&width=600&height=900&seq=at-film-afternoon-study&orientation=portrait',
    publishedAt: '2025-03-21',
    popularity: 91,
  },
  {
    id: 'red-velvet-room',
    title: '红丝绒房间',
    category: 'art',
    subcategory: '实验短片',
    year: 2022,
    region: '意大利',
    duration: 58,
    director: '马泰奥·里瓦',
    cast: ['琪亚拉·费拉', '卢卡·波尼'],
    rating: 7.9,
    tags: ['实验', '材质', '无对白'],
    summary: '没有对白的五十八分钟，全部由材质与光完成叙事。',
    synopsis:
      '全片没有一句对白，镜头在丝绒、镜面、水汽与皮肤之间缓慢移动。红色在不同介质上呈现出十几种层次，声音设计只保留环境噪音与呼吸。这是一部更接近当代艺术装置的作品，适合在大银幕上观看。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20art%20house%20film%20poster%20artwork%2C%20abstract%20close%20up%20of%20crimson%20velvet%20fabric%20folds%20with%20soft%20shadow%20and%20a%20narrow%20beam%20of%20light%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-red-velvet-room&orientation=portrait',
    publishedAt: '2025-02-14',
    popularity: 74,
  },
  {
    id: 'behind-the-lens',
    title: '镜头之后',
    category: 'documentary',
    subcategory: '行业纪实',
    year: 2024,
    region: '美国',
    duration: 88,
    director: '艾莉森·凯恩',
    cast: ['剧组访谈群像'],
    rating: 8.2,
    tags: ['行业', '幕后', '访谈'],
    summary: '把镜头转向幕后：灯光、场务与剪辑师的一天。',
    synopsis:
      '这部纪录片把摄影机交给剧组里最不被注意的人：灯光师、场务、剪辑助理与后期调色师。全片跟随三个制作周期，记录一部作品从勘景到交付的完整流程，也记录这些从业者对「被看见」这件事的看法。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20documentary%20poster%20artwork%2C%20silhouette%20of%20a%20film%20crew%20member%20holding%20a%20camera%20rig%20against%20a%20single%20warm%20studio%20light%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-behind-the-lens&orientation=portrait',
    publishedAt: '2025-05-06',
    popularity: 82,
  },
  {
    id: 'her-account',
    title: '她的自述',
    category: 'documentary',
    subcategory: '人物访谈',
    year: 2023,
    region: '英国',
    duration: 76,
    director: '娜奥米·哈特',
    cast: ['受访者匿名'],
    rating: 8.8,
    tags: ['访谈', '第一人称', '口述史'],
    summary: '六位从业者的口述史，关于选择、边界与自我叙述。',
    synopsis:
      '影片以固定机位记录六位受访者的自述，不做旁白引导，也不插入解释性画面。话题从入行契机谈到职业边界，再到如何面对外界的想象。导演只做一件事：把说话的时间完整地留给她们。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20documentary%20poster%20artwork%2C%20empty%20interview%20chair%20in%20a%20dark%20room%20with%20a%20single%20soft%20key%20light%20and%20a%20microphone%20stand%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20no%20text&width=600&height=900&seq=at-film-her-account&orientation=portrait',
    publishedAt: '2025-01-27',
    popularity: 79,
  },
  {
    id: 'video-era',
    title: '录像带时代',
    category: 'retro',
    subcategory: '录像带时代',
    year: 1989,
    region: '日本',
    duration: 102,
    director: '中村恒夫',
    cast: ['藤井沙织', '大岛隆'],
    rating: 7.8,
    tags: ['录像带', '年代感', '修复版'],
    summary: '1989 年的录像带作品，2024 年完成 2K 修复。',
    synopsis:
      '这部 1989 年的作品长期只以录像带形式流通，画质粗糙却保留了那个年代特有的质感。2024 年由原团队协助完成 2K 修复，重新校准了色彩与声音。它更像一份年代样本：布景、服装与对白方式，都清晰地指向一个已经过去的时间。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20retro%20film%20poster%20artwork%2C%20vintage%20video%20cassette%20and%20CRT%20television%20glow%20in%20a%20dark%20room%20with%20dusty%20air%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-video-era&orientation=portrait',
    publishedAt: '2024-12-11',
    popularity: 68,
  },
  {
    id: 'golden-years',
    title: '黄金年代',
    category: 'retro',
    subcategory: '黄金年代',
    year: 1976,
    region: '法国',
    duration: 110,
    director: '皮埃尔·勒克莱尔',
    cast: ['伊莎贝尔·杜兰', '米歇尔·罗'],
    rating: 8.0,
    tags: ['胶片', '70年代', '修复版'],
    summary: '1976 年胶片作品，以暖调摄影与长镜头著称。',
    synopsis:
      '1976 年拍摄于法国南部，全片使用 35mm 胶片，以大量长镜头与自然光完成。故事围绕一次夏季聚会展开，人物关系在餐桌上缓慢浮出水面。修复版保留了原始的颗粒与偏暖色调，也让当年的场面调度重新被看到。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20vintage%20film%20poster%20artwork%2C%20elegant%20woman%20in%20a%201970s%20summer%20dress%20seen%20from%20behind%20in%20a%20sunlit%20provence%20garden%20with%20long%20shadows%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20no%20text&width=600&height=900&seq=at-film-golden-years&orientation=portrait',
    publishedAt: '2024-11-05',
    popularity: 66,
  },
  {
    id: 'silent-confession',
    title: '无声告白',
    category: 'indie',
    subcategory: '新锐导演',
    year: 2024,
    region: '中国台湾',
    duration: 96,
    director: '林允安',
    cast: ['许安', '陈予晴'],
    rating: 8.5,
    tags: ['新锐导演', '长镜头', '城市'],
    summary: '一部关于「说不出口」的作品，长镜头里全是细节。',
    synopsis:
      '两个人在同一间公寓里住了三年，却始终没有把话说清楚。导演用手持长镜头跟随他们的日常：煮咖啡、晾衣服、在阳台上抽完一支烟。没有戏剧化的冲突，情绪的转折藏在每一次移开的目光里。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20indie%20film%20poster%20artwork%2C%20two%20distant%20figures%20standing%20apart%20on%20a%20balcony%20at%20dusk%20with%20laundry%20lines%20and%20warm%20window%20light%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20no%20text&width=600&height=900&seq=at-film-silent-confession&orientation=portrait',
    publishedAt: '2025-04-19',
    popularity: 85,
  },
  {
    id: 'midnight-tram',
    title: '午夜电车',
    category: 'indie',
    subcategory: '短片集',
    year: 2023,
    region: '日本',
    duration: 72,
    director: '多名新锐导演',
    cast: ['短片合集'],
    rating: 7.7,
    tags: ['短片集', '城市', '合集'],
    summary: '四部短片，同一趟末班电车，四个不同的夜晚。',
    synopsis:
      '四位新锐导演各自拍摄一段末班电车上的相遇，共用同一节车厢与同一套声音设计。四段故事互不解释，却在细节上彼此呼应：同一块广告牌、同一首歌、同一个打瞌睡的乘客。轻盈、克制，也足够有趣。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20indie%20film%20poster%20artwork%2C%20empty%20late%20night%20tram%20interior%20with%20warm%20ceiling%20lights%20and%20rain%20blurred%20windows%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-midnight-tram&orientation=portrait',
    publishedAt: '2025-03-02',
    popularity: 71,
  },
  {
    id: 'coastline',
    title: '海岸线',
    category: 'studio',
    subcategory: '亚洲厂牌',
    year: 2022,
    region: '泰国',
    duration: 105,
    director: '纳帕·柴亚',
    cast: ['帕琳·苏', '差纳·翁'],
    rating: 8.1,
    tags: ['海岛', '自然光', '慢节奏'],
    summary: '在雨季结束前的海岸线上，两个人的最后一次同行。',
    synopsis:
      '故事发生在泰国南部一段少有人至的海岸线。雨季将尽，两个人沿着公路向北，途中很少说话。影片几乎全部使用自然光与现场收音，潮汐、风声与远处摩托车的引擎构成了整部作品的底色。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%2C%20lone%20figure%20walking%20along%20a%20misty%20coastline%20at%20dawn%20with%20wet%20sand%20and%20soft%20waves%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-coastline&orientation=portrait',
    publishedAt: '2025-02-02',
    popularity: 76,
  },
  {
    id: 'velvet-smoke',
    title: '丝绒与烟雾',
    category: 'studio',
    subcategory: '欧美厂牌',
    year: 2021,
    region: '西班牙',
    duration: 112,
    director: '露西亚·贝尔蒙特',
    cast: ['索菲亚·雷耶斯', '马科斯·维拉'],
    rating: 7.9,
    tags: ['复古', '爵士', '舞台'],
    summary: '一间老式夜总会，一场持续到天亮的告别演出。',
    synopsis:
      '巴塞罗那的一间老式夜总会即将歇业，最后一场演出聚集了曾经在这里工作过的人。影片以舞台与后台交替推进，用爵士乐与烟雾把空间填满。故事并不复杂，但每一次谢幕都像真的告别。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%2C%20vintage%20jazz%20club%20stage%20with%20a%20retro%20microphone%20in%20smoke%20and%20warm%20spotlight%20beam%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-velvet-smoke&orientation=portrait',
    publishedAt: '2025-01-12',
    popularity: 69,
  },
  {
    id: 'mirror-hotel',
    title: '镜中旅馆',
    category: 'drama',
    subcategory: '都市情感',
    year: 2025,
    region: '韩国',
    duration: 121,
    director: '尹度贤',
    cast: ['韩彩元', '朴时厚', '金多恩'],
    rating: 8.7,
    tags: ['新作', '旅馆', '多视角'],
    summary: '同一间旅馆客房，三个视角，一段被反复改写的关系。',
    synopsis:
      '影片把全部场景放在一间临街的旅馆客房里，用三位住客的视角反复讲述同一段相遇。每一次重述都会改变细节，观众需要自己判断哪一版更接近真实。导演在空间调度上极为讲究，镜子、窗帘与门缝都成为叙事工具。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20artwork%2C%20empty%20hotel%20corridor%20with%20mirrors%20reflecting%20warm%20lamp%20light%20and%20a%20half%20open%20door%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20sophisticated%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=at-film-mirror-hotel&orientation=portrait',
    publishedAt: '2025-06-08',
    popularity: 98,
  },
  {
    id: 'before-dawn',
    title: '晨光之前',
    category: 'art',
    subcategory: '唯美摄影',
    year: 2025,
    region: '冰岛',
    duration: 86,
    director: '艾娃·约恩斯',
    cast: ['卡特琳·斯', '奥拉夫·林'],
    rating: 8.9,
    tags: ['极昼', '自然', '新作'],
    summary: '在几乎没有黑夜的夏天，两个人重新学习如何入睡。',
    synopsis:
      '冰岛的夏天几乎没有黑夜，一对久别重逢的人在狭小的木屋里度过极昼。影片用大量广角全景与极少的对白，把人的尺度放得很小。光线始终停留在黄昏的位置，让人分不清是清晨还是午夜。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20art%20house%20film%20poster%20artwork%2C%20minimal%20icelandic%20landscape%20with%20a%20small%20wooden%20cabin%20under%20a%20pale%20midnight%20sun%20and%20low%20mist%2C%20moody%20low%20key%20lighting%2C%20deep%20charcoal%20black%20background%20with%20warm%20ember%20and%20muted%20red%20tones%2C%20atmospheric%20haze%2C%20elegant%20negative%20space%2C%20fine%20film%20grain%20texture%2C%20no%20text&width=600&height=900&seq=at-film-before-dawn&orientation=portrait',
    publishedAt: '2025-06-21',
    popularity: 94,
  },
];

export const getFilmById = (id: string) => films.find((film) => film.id === id);